// extracted by mini-css-extract-plugin
export default {"container":"TableOverlay_container__ZMcGM"};